(function () {
  var header = document.querySelector('.section-header');
  if (!header) return;

  var THRESHOLD = 56;
  var condensed = false;

  function update() {
    var shouldCondense = window.scrollY > THRESHOLD;
    if (shouldCondense === condensed) return;
    condensed = shouldCondense;
    header.classList.toggle('mg-header--condensed', condensed);
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
})();
